export default {
      id: "icon-close-usage",
      viewBox: "0 0 8.13 8.13",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-close",
      toString: function () {
        return this.url;
      }
    }